<template>
  <div class="detail step1Manager">
    <p class="institutiomname">
      {{ title }}
      <el-tag
        size="mini"
        class="institutiomname-checkstate"
        :type="listTags[checkState][0]"
      >
        {{ listTags[checkState][1] }}
      </el-tag>
    </p>
    <div class="title clearfix">
      <p class="type pull-left type-title">入驻类型:</p>
      <el-tag
        class="type-tag"
        size="mini"
        effect="dark"
        :type="
          getType === '新设' ? '' : getType === '迁入' ? 'warning' : 'success'
        "
        >{{ getType }}</el-tag
      >
      <p class="type pull-left" style="margin-left: 40px">
        入驻小镇:{{ getTownName }}
      </p>
      <div class="type-line"></div>
      <div class="type-time">填报时间：{{ date }}</div>
      <!-- <p class="time pull-right">填报时间: 2019-06-27</p> -->
    </div>
    <!-- form -->
    <table-form
      :dataSource="formConf"
      ref="form"
      :tableData="formData"
      :disable="true"
    ></table-form>
    <!-- 出资人信息 -->
    <table-temp
      class="item-table"
      title="出资人信息"
      :flag="1"
      :tableData="investorData"
      :columnData="investorConf"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 联系人信息 -->
    <table-temp
      class="item-table"
      title="联系人信息"
      :flag="2"
      :tableData="contactData"
      :columnData="contactCommonConf[0]"
      text="详情"
      @editTable="editTable"
      :isEdit="false"
    ></table-temp>

    <!-- 高级管理人信息 tableData、legalData为记录数据 columnData、newContactConf标头字段名  -->
    <table-temp
      class="item-table"
      title="高级管理人信息"
      :flag="3"
      :tableData="legalData"
      :columnData="newContactConf"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 实际控制人信息 -->
    <table-temp
      class="item-table"
      title="实际控制人信息"
      :flag="4"
      :tableData="complianceData"
      :columnData="contactCommonConf[2]"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 办公场所 -->
    <table-temp
      class="item-table"
      title="办公场所"
      :flag="6"
      :tableData="officeData"
      :columnData="uploadConfig[1]"
      :isEdit="false"
    ></table-temp>

    <!-- 其他资料 -->
    <table-temp
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherData"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>

    <!--详情 -->
    <common-dialog
      :dialogVisible="dialogVisible"
      :dtitle="dtitle"
      :tableData="commonData"
      :dataSource="commoncolumn"
      @closeDialog="closeDialog"
    ></common-dialog>
  </div>
</template>

<script>
const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

import TableForm from "common/components/form/tableForm";
import {
  newStep1,
  step2,
  step3,
  uploadConfig,
  step4Other,
} from "@/conf/newAgency";
import { AgencyStep2 } from "@/conf/Agency";
import TableTemp from "@table/table2";
import CommonDialog from "./dialog/common-dialog";
import { getLegalDetail, getTownBaiscList, selectDic } from "common/js/api";

export default {
  props: ["data", "checkState", "date"],

  components: {
    TableForm,
    TableTemp,
    CommonDialog,
  },

  computed: {
    getType() {
      const institutionCode = this.$route.query.institutionCode;
      if (institutionCode.slice(2, 4) == "XS") return "新设";
      else return "迁入";
    },
    getTownName() {
      return this.townName;
    },
  },

  data() {
    return {
      title: "",
      // form
      formConf: [],
      formData: {},
      // 出资人
      investorConf: [],
      contactCommonConf: step3,
      uploadConfig,
      step4Other,
      investorData: [],
      //联系人信息
      contactData: [
        {
          name: "出资人",
        },
      ],
      // 法定代表人
      legalData: [
        {
          name: "出资人",
        },
      ],
      // 合规
      complianceData: [
        {
          name: "出资人",
        },
      ],
      // 财务负责人
      financialData: [
        {
          name: "出资人",
        },
      ],
      //
      companyData: [],
      officeData: [],
      otherData: [],
      otherInfo: {},
      // dialog
      dialogVisible: false,
      dtitle: "",
      commonData: [],
      commoncolumn: [],
      isAgency: false,
      newContactConf: [],
      townName: "",
      listTags: {
        0: ["info", "未提交"],
        1: ["", "待审核"],
        2: ["warning", "审核中"],
        3: ["success", "已通过"],
        4: ["danger", "未通过"],
      },
    };
  },

  created() {
    this.setColumn();
    this.getTownList();
  },

  mounted() {
    this.isAgency =
      this.$route.path == "/FundManagement/FundDetail" ? "false" : "true";
    this.investorConf =
      this.$route.path == "/FundManagement/FundDetail" ? step2 : AgencyStep2;
    this.newContactConf = this.contactCommonConf[1].filter((item) => {
      return (
        item.field !== "experienceInvest" &&
        item.field !== "experienceEducation" &&
        item.field !== "experienceJob"
      );
    });
  },

  methods: {
    async getSelect() {
      const result = await selectDic("5");
      const INVEST_INDUSTRY = result.result.INVEST_INDUSTRY;
      INVEST_INDUSTRY.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        this.formConf[10].options.push(data);
      });
      console.log("detail组件--上方的打印log为tableForm挂载时执行,下方重复打印部分为传入tableData后,触发watch");
      console.log("detail组件--拿取后台selection配置formConf",this.formConf);
    },

    async getTownList() {
      const { result } = await getTownBaiscList();
      this.townName = result[0].fundTownName;
    },
    setColumn() {
      let column = this.$lodash.cloneDeep(newStep1);
      // column[14] = {
      //   label: "展业计划",
      //   field: "devPlanFileOrignName",
      //   formtype: "",
      //   require: false
      // };
      this.formConf = column;
      this.getSelect();
    },

    editTable(data) {
      const flag = data.flag;
      console.log("点击详情后--detail组件--editTable接收到的data(即为对象{scope,flag})",data);
      console.log("点击详情后--detail组件--editTable接收到的data.scope.row",data.scope.row);
      this.commonData = this.$lodash.cloneDeep(data.scope.row);
      console.log("点击详情后--detail组件--克隆scope.row后的this.commonData",this.commonData.qualification)
      const id = data.scope.row.id;

      switch (flag) {
        case 1:
          this.commoncolumn = this.investorConf;
          this.dtitle = "出资人详情";
           if (this.commonData.qualified == "是") {
            this.commonData.qualified = "1";
          }
          if (this.commonData.qualified == "否") {
            this.commonData.qualified = "0";
          }
          break;
        case 2:
          this.commoncolumn = this.contactCommonConf[0];
          this.dtitle = "联系人详情";
          break;
        case 3:
          this.commoncolumn = this.contactCommonConf[1];
          this.dtitle = "高级管理人详情";
          if (this.commonData.qualification == "是") {
            this.commonData.qualification = "1";
          }
          if (this.commonData.qualification == "否") {
            this.commonData.qualification = "0";
          }
          console.log("点击详情后--detail组件--this.commonData.qualification",this.commonData.qualification);
          console.log("点击详情后--detail组件--this.commonData",this.commonData);
          this.$set(this.commonData,"dte",new Date());

          break;
        case 4:
          this.commoncolumn = this.contactCommonConf[2];
          this.dtitle = "实际控制人详情";
          break;
        case 5:
          this.commoncolumn = this.contactCommonConf[0];
          this.dtitle = "财务负责人详情";
          break;
      }
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },

    convernSexData(data) {
      data.forEach((item) => {
        item.gender = JSON.parse(item.gender) == true ? "男" : "女";
        item.workQualification =
          JSON.parse(item.workQualification) == true ? "是" : "否";
      });
      return data;
    },
    converInverstorData(data) {
      let newData = JSON.parse(JSON.stringify(data));
      newData.forEach((item) => {
        item.qualified = item.qualified ? "是" : "否";
      });
      return newData;
    },
    convernData(data) {
      console.log("detail组件--convertData方法--传入的data数据", data);
      let datatemp =  this.$lodash.cloneDeep(data);
      datatemp.forEach((item) => {
        if (item.personType == 2) {
          item.personType = "法定代表人/执行事务合伙人（委派代表）";
        }
        if (item.personType == 3) {
          item.personType = "投资经理";
        }
        if (item.personType == 4) {
          item.personType = "合规风控负责人";
        }
        if (item.qualification == 1) {
          item.qualification = "是";
        }
        if (item.qualification == 0 || item.qualification == null) {
          item.qualification = "否";
        }
      });
      return datatemp;
    },
    convernOtherData(data) {
      if (!data || !Object.keys(data).length) return;
      this.companyData = [];
      this.officeData = [];
      this.otherData = [
        {
          id: 0,
          name: "入驻申请书",
          oldFile: "",
          newFile: "",
        },
        {
          id: 1,
          name: "公司章程或合伙协议",
          oldFile: "",
          newFile: "",
        },
        {
          id: 2,
          name: "展业计划书/商业计划书",
          oldFile: "",
          newFile: "",
          title: "已登记无须提供",
        },
        {
          id: 3,
          name: "私募基金管理人股权架构合理性说明（如设置超过三层）",
          oldFile: "",
          newFile: "",
        },
        {
          id: 4,
          name: "其他材料",
          oldFile: "",
          newFile: "",
        },
      ];

      let officeData = {
        office:
          data.office[0].officeProvince +
          data.office[0].officCity +
          data.office[0].officDistrict,
        realOfficeAddress: data.office[0].realOfficeAddress,
        officeArea: data.office[0].officeArea,
        officRentOrignName: data.office[0].officRentOrignName,
        officRentStorePath: data.office[0].officRentStorePath,
      };
      this.officeData.push(officeData);
      //入驻申请书
      this.otherData[0].oldFile = data.other[0].inApplicationOrignName;
      this.otherData[0].newFile = data.other[0].inApplicationStorePath;
      //公司章程或合伙协议
      this.otherData[1].oldFile = data.other[0].regulationOrignName;
      this.otherData[1].newFile = data.other[0].regulationStorePath;
      //展业计划书/商业计划书
      this.otherData[2].oldFile = data.other[0].planFileOrignName;
      this.otherData[2].newFile = data.other[0].planFileStorePath;
      //私募基金管理人股权架构合理性说明（如设置超过三层）
      this.otherData[3].oldFile = data.other[0].rationalityExplainOrignName;
      this.otherData[3].newFile = data.other[0].rationalityExplainStorePath;
      //其他材料
      this.otherData[4].oldFile = data.other[0].otherFileOrignName;
      this.otherData[4].newFile = data.other[0].otherFileStorePath;

      // this.otherData.push(otherData);
    },
  },

  watch: {
    data: {
      handler(result) {
        console.log("detail组件---watch传入数据props的data");
        // console.log(result);
        // this.formData = result.basic;
        // this.formData.map(item => {
        //   if(item.clusterRegiste === true) {
        //     item.isCluster = '是'
        //   }else {
        //     item.isCluster = '否'
        //   }
        //   if(item.officeNeed === true) {
        //     item.isOffice = '是'
        //   }else {
        //     item.isOffice = '否'
        //   }
        // })
        this.formData = result.basic ? result.basic : {};
        this.formData.clusterRegiste = this.formData.clusterRegiste?"1":"0";
        console.log("detail组件---this.formData--外面的大表basic信息", this.formData);
        let sums = 0;
        result.investor.forEach((column, index) => {
          sums += column.capture;
        });
        result.investor.forEach((column, index) => {
          column.capturePercent = ((column.capture / sums) * 100).toFixed(2);
          //  column.capturePercent.toFixed(2)
        });
        this.title = result.basic ? result.basic.institutionName : [];
        this.investorData = this.converInverstorData(result.investor);
        // this.investorData = result.investor;
        this.contactData = result.person.linkman;
        this.legalData = this.convernData(result.person.expertMgrman);
        this.complianceData = result.person.controlman;
        this.convernOtherData(result.otherInfo);
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  margin: 0 0 20px 0px;
  font-size: 14px;
  color: #6c7885;
  display: flex;
  align-items: center;
}
.item-table {
  margin-top: 50px;
}
.institutiomname {
  font-size: 24px;
  font-family: AlibabaM;
  color: #191818;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  &-checkstate {
    background: #e2f1ff;
    border-radius: 11px;
    font-family: Alibaba;
    margin-left: 20px;
  }
}
</style>

